var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51144 0C8.99694 0 9.48245 0 9.96795 0C10.2429 0.0409262 10.5236 0.0818524 10.7986 0.128625C16.5837 1.08747 20.0407 7.27902 17.8004 12.6988C17.4903 13.4472 17.0516 14.1371 16.6422 14.9205C16.6656 14.9381 16.7592 14.9965 16.8352 15.0725C17.9934 16.2243 19.1516 17.3702 20.2922 18.5396C20.5613 18.8144 20.766 19.1593 21 19.475C21 19.6504 21 19.8258 21 20.0012C20.9825 20.0246 20.9591 20.0421 20.9532 20.0714C20.5905 21.077 19.561 21.3109 18.8006 20.5508C17.5547 19.3113 16.3087 18.066 15.0687 16.8207C14.9926 16.7447 14.9166 16.6803 14.8347 16.5985C14.7645 16.6511 14.7118 16.6862 14.6534 16.7271C12.1322 18.4869 9.38301 18.9605 6.45244 18.0426C2.08875 16.6803 -0.607843 12.3948 0.117488 7.88122C0.743379 4.01661 3.03051 1.50258 6.78 0.344949C7.34155 0.175398 7.93234 0.111085 8.51144 0ZM9.23677 15.9904C12.9746 15.9963 15.9812 13.0028 15.9987 9.26686C16.0104 5.51919 13.0038 2.50234 9.25432 2.4965C5.52237 2.49065 2.50991 5.48411 2.49821 9.22009C2.48066 12.9678 5.48728 15.9846 9.23677 15.9904Z",
    fill: "#011367"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDark);
export default __webpack_public_path__ + "static/media/search-dark.0d116f7e43a5cc5e9e3a90c4bc1896e2.svg";
export { ForwardRef as ReactComponent };